var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inventory-template',{attrs:{"currencies":_vm.currencies,"prestige-stones":_vm.prestigeStone,"disabled":_vm.isFrozen}},[_c('heirloom-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }